import { useMemo } from "react";
import { List, RadioButton, Text } from "react-native-paper";
import Box from "../Box";
import ItemList from "../ItemList";
import type { ListItem } from "../ItemList";
import { useOnboarding } from "./OnboardingProvider";
import { OnboardingBox } from "./components/OnboardingBox";
import { LEVEL_OPTIONS } from "./constants";

type Props = {
	title: string;
	description?: string;
};

export const OnboardingLevelScreen = ({ title, description }: Props) => {
	const { selectedLevelId, onSelectLevel } = useOnboarding();

	const items: ListItem[] = useMemo(
		() =>
			LEVEL_OPTIONS.map((level) => ({
				id: level.id,
				title: level.title,
				description: level.description,
				customLeft: (p) => (
					<List.Icon
						{...p}
						icon={() => (
							<RadioButton.Android
								value={level.id}
								status={selectedLevelId === level.id ? "checked" : "unchecked"}
								onPress={() => onSelectLevel(level.id)}
							/>
						)}
					/>
				),
			})),
		[selectedLevelId, onSelectLevel],
	);

	return (
		<Box flex={1} gap={16}>
			<OnboardingBox>
				<Box gap={14}>
					<Text variant="titleLarge">{title}</Text>
					{description ? <Text variant="bodyMedium">{description}</Text> : null}
				</Box>
			</OnboardingBox>
			<Box flex={1}>
				<ItemList
					items={items}
					onSelect={onSelectLevel}
					selectedId={selectedLevelId}
				/>
			</Box>
		</Box>
	);
};
